const { createHigherOrderComponent } = wp.compose;
const withCustomClassName = createHigherOrderComponent( ( BlockListBlock ) => {
    return ( props ) => {
        if ( props.attributes.name == 'renoun/column' ) {
            let foundationClasses = ['columns'];
            const colKey = 'field_6413cebe6d56c';

            // Add vertical align classes
            if ( props.attributes.hasOwnProperty('alignContent') ) {
                let val = props.attributes.alignContent;
                val = val == 'center' ? 'middle' : val;
                foundationClasses.push( `align-self-${val}`)
            }

            // Add text align classes
            if ( props.attributes.hasOwnProperty('alignText') ) {
                foundationClasses.push( `text-${props.attributes.alignText}`)
            }


            // Initial load of column with no data available
            if ( typeof props.attributes.data == 'undefined' ) {
                foundationClasses.push('small-12');
            // Load of column after save with field labels used
            } else if ( props.attributes.data.hasOwnProperty('columns') ) {
                for( const colKey in props.attributes.data ) {
                    if ( ! props.attributes.data[colKey] || colKey.charAt(0) == '_' ) {
                        continue;
                    }

                    const parts = colKey.split('_');
                    if ( parts.length == 2 ) {
                        continue;
                    }

                    if ( parts[2] == 'span' ) {
                        foundationClasses.push( `${parts[1]}-${props.attributes.data[colKey]}` );
                    } else {
                        foundationClasses.push( `${parts[1]}-${parts[2]}-${props.attributes.data[colKey]}` );
                    }
                }
            // Preview load of column using field keys
            } else if ( props.attributes.data.hasOwnProperty( colKey ) ) {
                const data = props.attributes.data[ colKey ];
                const classKeys = {
                    field_6413d0756d56f: 'span', 
                    field_6413d0946d570: 'offset',
                    field_6413d0b36d571: 'order',
                    field_6413d05a6d56e: 'xxlarge',
                    field_6413d14c47e95: 'span',
                    field_6413d14c47e96: 'offset', 
                    field_6413d14c47e97: 'order',
                    field_6413d14c47e94: 'xlarge',        
                    field_6413d15c47e99: 'span', 
                    field_6413d15c47e9a: 'offset',  
                    field_6413d15c47e9b: 'order', 
                    field_6413d15c47e98: 'large',        
                    field_6413d16947e9d: 'span', 
                    field_6413d16947e9e: 'offset',
                    field_6413d16947e9f: 'order',
                    field_6413d16947e9c: 'medium',       
                    field_6413d17b47ea1: 'span', 
                    field_6413d17b47ea2: 'offset', 
                    field_6413d17b47ea3: 'order', 
                    field_6413d17b47ea0: 'small'        
                };

                for( const breakpoint in data ) {
                    for( const prop in data[breakpoint] ) {
                        
                        if ( data[breakpoint][prop] ) {
                            if ( 'span' == classKeys[prop] ) {
                                foundationClasses.push( `${classKeys[breakpoint]}-${data[breakpoint][prop]}` );
                            } else {
                                foundationClasses.push( `${classKeys[breakpoint]}-${classKeys[prop]}-${data[breakpoint][prop]}` );
                            }
                        }
                    }
                }
            }
            return <BlockListBlock { ...props } className={ foundationClasses.join(' ') } />;
        } else {
            return <BlockListBlock {...props} />
        }
    };
}, 'withClientIdClassName' );

wp.hooks.addFilter( 'editor.BlockListBlock', 'renoun/column', withCustomClassName );